module.exports = __webpack_public_path__ + "img/no-results.8a3e4c9b.png";